import { noise2D } from "../utils/noise.js";
import { mulberry32, getTileSeed } from "../utils/prng.mjs";

export class tile {
    constructor(xPos, yPos, worldSeed, elementGrid, tierVal, isLoading = false) {
        this.xPos = xPos;
        this.yPos = yPos;
        this.magnitude = Math.abs(xPos) + Math.abs(yPos);
        this.worldSeed = worldSeed;

        this.prngSeed = `${this.xPos}_${this.yPos}_${this.worldSeed}`;
        this.prngOffset = 0;

        this.stats = {
            element: null,
            tier: tierVal,
            capacity: null,
            strengthLevel: null,
            sanctuaryLevel: null,
            sanctuaryBoost: null,
        };

        this.currentQuest = null;
        this.questStatus = "not-accepted";

        if (!isLoading) {
            this.generateTile(elementGrid);
        }
    }

    toJSON() {
        // Only save if the tile has been modified via quests
        if (this.questStatus === "not-accepted" && this.prngOffset === 0) {
            return undefined; 
        }
        
        const progress = this.currentQuest ? this.currentQuest.killProgress : 0;

        // Clean, decoupled serialization
        return [
            this.xPos, 
            this.yPos, 
            this.prngOffset, 
            this.questStatus, 
            this.stats.element, 
            this.stats.tier,
            this.stats.capacity, 
            this.stats.strengthLevel, 
            this.stats.sanctuaryLevel, 
            this.stats.sanctuaryBoost,
            progress
        ];

        //test
    }

    generateElement(elementGrid) {
        const noiseScale = 5;
        const noiseX = noise2D(this.xPos / noiseScale, this.yPos / noiseScale, this.worldSeed);
        const noiseY = noise2D((this.xPos + 100) / noiseScale, (this.yPos + 100) / noiseScale, this.worldSeed + 5678);
        const gridLen = elementGrid.length;

        let indexX = Math.floor(noiseX * gridLen);
        let indexY = Math.floor(noiseY * gridLen);
        if (indexX >= gridLen) indexX = gridLen - 1;
        if (indexY >= gridLen) indexY = gridLen - 1;

        this.stats.element = elementGrid[indexX][indexY];
    }

    generateTile(elementGrid) {
        const seededRoll = mulberry32(getTileSeed(this.xPos, this.yPos, this.worldSeed, this.prngOffset));
        //console.log(elementGrid);
        let temp;
 
        this.generateElement(elementGrid);
        
        temp = seededRoll();
        this.stats.capacity = (Math.floor(temp * 100) + 1) * 10;

        temp = seededRoll();
        this.stats.strengthLevel = (Math.floor(temp * 10) + 1);

        temp = seededRoll();
        this.stats.sanctuaryBoost = ((Math.floor(temp * 10) / 10) + 1);

        this.currentQuest = this.getQuest();
    }

    updateQuest() {
        this.currentQuest = this.getQuest();
    }

    getQuestID(params) {
        return `${params.xPos}_${params.yPos}_${params.worldSeed}_${params.offset}`;
    }

    getQuest() {
        this.questStatus = "not-accepted";
        //incrementing prngOffset to get new randomness every 
        this.prngOffset++;

        const usedParams = {
            xPos: this.xPos,
            yPos: this.yPos,
            worldSeed: this.worldSeed,
            offset: this.prngOffset,
        }

        let questID = this.getQuestID(usedParams)

        let tileSeed = getTileSeed(usedParams.xPos, usedParams.yPos, usedParams.worldSeed, usedParams.offset)
        const questRoll = mulberry32(tileSeed)

        let temp;

        //rewards 1-3 spell shards
        temp = questRoll();
        let questRewardAmount = (Math.floor(temp * 3) + 1);

        //spell shard rewards are from 1-5
        temp = questRoll();
        let questTier = (Math.floor(temp * 5) + 1);

        //total amount of monsters that need to be kill is dependant on how far out the tile is
        temp = questRoll();
        let questKillAmount = Math.floor(temp * Math.pow(this.magnitude, 2)) + 1;

        let questElement = this.stats.element;
        let rewardElement = questElement.toLowerCase();

        return {
            id: questID,
            questNum: usedParams.offset,
            element: questElement,
            killAmount: questKillAmount,
            killProgress: 0,
            reward: {
                usedParams,
                id: questID,
                element: rewardElement,
                tier: questTier,
                amount: questRewardAmount
            }
        }
    }
}